import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationSection = ({ location }) => {
  return (
    <div className="bg-card rounded-xl shadow-warm-md p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="MapPin" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold">Location & Service Area</h2>
          <p className="text-sm text-muted-foreground">Delivery and pickup information</p>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <div className="mb-6">
            <h3 className="font-caption font-semibold text-sm mb-3">Kitchen Address</h3>
            <div className="flex items-start gap-3 p-4 bg-muted rounded-lg">
              <Icon name="Home" size={20} color="var(--color-primary)" />
              <div>
                <p className="font-medium mb-1">{location?.address}</p>
                <p className="text-sm text-muted-foreground">{location?.city}, {location?.state} {location?.zipCode}</p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h3 className="font-caption font-semibold text-sm mb-3">Service Radius</h3>
            <div className="flex items-center gap-3 p-4 bg-primary/10 rounded-lg">
              <Icon name="MapPin" size={20} color="var(--color-primary)" />
              <div>
                <p className="font-medium text-primary">Delivers within {location?.serviceRadius} miles</p>
                <p className="text-sm text-muted-foreground">Free delivery over $30</p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h3 className="font-caption font-semibold text-sm mb-3">Contact Information</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3 p-4 bg-muted rounded-lg">
                <Icon name="Phone" size={20} color="var(--color-primary)" />
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Phone</p>
                  <p className="font-medium">{location?.phone}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 bg-muted rounded-lg">
                <Icon name="Mail" size={20} color="var(--color-primary)" />
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Email</p>
                  <p className="font-medium">{location?.email}</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-caption font-semibold text-sm mb-3">Operating Hours</h3>
            <div className="space-y-2">
              {location?.operatingHours?.map((hours, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-3 bg-muted rounded-lg"
                >
                  <span className="font-medium text-sm">{hours?.day}</span>
                  <span className="text-sm text-muted-foreground">{hours?.hours}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div>
          <div className="w-full h-full min-h-[400px] rounded-lg overflow-hidden shadow-warm">
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              title={location?.address || 'Supplier location'}
              referrerPolicy="no-referrer-when-downgrade"
              src={(() => {
                console.log(location);
                // Prefer precise coordinates when available, otherwise fall back to address text
                if (location?.coordinates?.lat && location?.coordinates?.lng) {
                  return `https://www.google.com/maps?q=${location.coordinates.lat},${location.coordinates.lng}&z=14&output=embed`;
                }
                const addrParts = [location?.address, location?.city, location?.state, location?.zipCode, location?.country]
                  .filter(Boolean)
                  .join(', ');
                const q = encodeURIComponent(addrParts || location?.address || location?.label || location?.country || '');
                return `https://www.google.com/maps?q=${q}&z=14&output=embed`;
              })()}
              className="border-0"
            />
          </div>
        </div>
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <h3 className="font-caption font-semibold text-sm mb-4">Nearby Landmarks</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {location?.landmarks?.map((landmark, index) => (
            <div
              key={index}
              className="flex items-center gap-3 p-3 bg-muted rounded-lg"
            >
              <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm">{landmark}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LocationSection;